import { render } from "./header-bar-links.vue?vue&type=template&id=225fb4ab&scoped=true"
import script from "./header-bar-links.vue?vue&type=script&lang=js"
export * from "./header-bar-links.vue?vue&type=script&lang=js"

import "./header-bar-links.vue?vue&type=style&index=0&id=225fb4ab&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-225fb4ab"

export default script